(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired124"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired124"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lT1Za", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fef04652c775fc64$export$1b5e630bc3aea29f; });

var $cOS50 = parcelRequire("cOS50");

var $i1nao = parcelRequire("i1nao");

var $7HS0T = parcelRequire("7HS0T");

var $8YVFh = parcelRequire("8YVFh");
function $fef04652c775fc64$export$1b5e630bc3aea29f(arr) {
    return (0, $cOS50._array_without_holes)(arr) || (0, $i1nao._iterable_to_array)(arr) || (0, $8YVFh._unsupported_iterable_to_array)(arr) || (0, $7HS0T._non_iterable_spread)();
}

});
parcelRegister("cOS50", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $95541aa473131508$export$7e0947b5ad3404e2; });

var $822BU = parcelRequire("822BU");
function $95541aa473131508$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $822BU._array_like_to_array)(arr);
}

});
parcelRegister("822BU", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $5d9088fdefde415d$export$79e617b1955a2616; });
function $5d9088fdefde415d$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("i1nao", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $d1ea4a6590f30b83$export$1eb58a6e75231000; });
function $d1ea4a6590f30b83$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("7HS0T", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $59c6727f1c363cc6$export$e6f3c4780d19eb2b; });
function $59c6727f1c363cc6$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("8YVFh", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $68a0a85bb5bfa568$export$a5be06335b3a083c; });

var $822BU = parcelRequire("822BU");
function $68a0a85bb5bfa568$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $822BU._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $822BU._array_like_to_array)(o, minLen);
}

});


//

var $lT1Za = parcelRequire("lT1Za");
$("body").on("click", 'button[data-action="redirect"]', zeno_debounce(200, function(event) {
    window.location = $(this).data("zeno-clickable-url");
}));
//show any additional fields for the selected category
$("body").on("change", 'select[name="activity-category"]', zeno_debounce(200, function(event) {
    $0d362ce505e5b307$var$updateForm();
}));
//
$("body").on("change", "div.activity-type-dropdown", zeno_debounce(200, function(event) {
    $0d362ce505e5b307$var$updateForm();
}));
setTimeout($0d362ce505e5b307$var$updateForm, 300);
//handle the requirement for a hidden class...
var $0d362ce505e5b307$var$customFormStyles = new CSSStyleSheet();
$0d362ce505e5b307$var$customFormStyles.replaceSync(".hidden { display: none; }");
document.adoptedStyleSheets = (0, $lT1Za._)(document.adoptedStyleSheets).concat([
    $0d362ce505e5b307$var$customFormStyles
]);
//
function $0d362ce505e5b307$var$updateForm() {
    $("div.activityToken").addClass("hidden");
    $("div.activity-type-dropdown").addClass("hidden").filter('[data-category="' + $('select[name="activity-category"]').val() + '"]').removeClass("hidden");
    var selectedActivity = $('select[name="activity-category"] option:selected').val().toLowerCase();
    var selectedOption = $('select[name="activity-type-'.concat(selectedActivity, '"] option:selected')).data("activitytype").toLowerCase();
    // use the name
    if (selectedActivity == "reading") {
        $('select[name="activity-duration"] option:not([value="1"])').prop("hidden", true);
        $('select[name="activity-duration"]').val(1);
        $("div.requireAssessment").addClass("hidden");
        $("div.requireAssessment").addClass("hidden");
        if (selectedOption == "nrla property magazine") {
            $('input[name="activity-organisation"]').val("NRLA");
            $("div.activityOrganisation").addClass("hidden");
            // token
            $("div.activityToken").removeClass("hidden");
            $('input[name="activity-token"]').closest("div.input-group").addClass("input-required");
            $('input[name="activity-token"]').prop("required", false);
        } else {
            $("div.activityOrganisation").removeClass("hidden");
            // token
            $("div.activityToken").addClass("hidden");
            $('input[name="activity-token"]').prop("required", false);
        }
    } else {
        $('select[name="activity-duration"] option').prop("hidden", false);
        $('select[name="activity-duration"]').val();
        $("div.requireAssessment").removeClass("hidden");
        $("div.activityOrganisation").removeClass("hidden");
        // token
        $("div.activityToken").addClass("hidden");
        $('input[name="activity-token"]').prop("required", false);
    }
}
//
function $0d362ce505e5b307$var$updateTextareaCounter(element) {
    if ($(element).find(" + small.counter").length == 0) $(element).after('<small class="counter" style="float: right;"></small>');
    var maxCharacters = 1024;
    var totalCharacters = $(element).val().length;
    $(element).find(" + small.counter").css("color", totalCharacters > maxCharacters ? "#ff0024" : "#252525");
    $(element).find(" + small.counter").text(totalCharacters + "/" + maxCharacters);
}
//
$("body").on("keyup", 'textarea[name="activity-member-comments"]', function(event) {
    $0d362ce505e5b307$var$updateTextareaCounter(event.target);
});
$0d362ce505e5b307$var$updateTextareaCounter(document.querySelector('textarea[name="activity-member-comments"]'));
//
$("body").on("change", 'div[data-name="activity-type-dropdown"] select', zeno_debounce(200, function(event) {
    var tokenType = $(this).find('option[value="' + $(this).val() + '"]').data("tokentype");
    if (tokenType !== "") $("#verificationToken").removeClass("hidden");
    else if (!$("#verificationToken").hasClass("hidden")) $("#verificationToken").addClass("hidden");
}));

})();
//# sourceMappingURL=accreditation.min.js.map
